









import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import PositionController from "./positionController/positionController.vue";
import LayerController from "./layerController/layerController.vue";
import EditController from "./editController/editController.vue";
import CopyController from "./copyController/copyController.vue";

import { NativeHelper } from '@/helper/nativeHelper';

@Component({
    components: {
        PositionController,
        LayerController,
        EditController,
        CopyController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PopupController extends Vue 
{
    @Prop() controllerType! : string;

    private onDoCommand(command: string, parameter: any)
    {
        this.$emit("doCommand", command, parameter);
    }

    private onTouchMove()
    {
        this.$emit("viewtouchmove");
    }

    private onTouchEnd()
    {
        this.$emit("viewtouchend");
    }
}
